var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1579 2.38158L13.0835 14.0898L8.06997 9.23149C7.64969 8.82395 6.96598 8.82395 6.54568 9.23149C6.1254 9.63903 6.1254 10.302 6.54568 10.7096L12.3214 16.3102C12.5334 16.5157 12.8068 16.6151 13.0835 16.6151C13.3603 16.6151 13.6337 16.5124 13.8457 16.3102L26.6853 3.86279C27.1056 3.45526 27.1056 2.79227 26.6853 2.38472C26.2615 1.97371 25.5816 1.97371 25.1577 2.38125L25.1579 2.38158Z",
    fill: "#3C69AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9863 2.16632C15.6126 2.16632 18.0208 3.14154 19.9071 4.75573L21.3872 3.21704C19.1244 1.21146 16.1974 -0.000976562 12.9863 -0.000976562C5.82714 -0.000737019 0 6.05746 0 13.4996C0 20.9417 5.82744 27.0001 12.9863 27.0001C20.1449 27.0001 25.9626 20.9419 25.9626 13.4996C25.9626 11.7652 25.6487 10.1098 25.0673 8.58168L23.4322 10.2816C23.723 11.3017 23.8815 12.3835 23.8815 13.4996C23.8815 19.7501 18.9924 24.8329 12.99 24.8329C6.9776 24.8329 2.08842 19.7501 2.08842 13.4996C2.08496 7.24917 6.97406 2.16638 12.9864 2.16638L12.9863 2.16632Z",
    fill: "#3C69AC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkCircle);
export default __webpack_public_path__ + "static/media/mark-circle.ad88ec6b.svg";
export { ForwardRef as ReactComponent };